var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"home"}},[_c('v-content',[_c('top-image'),_c('section',{attrs:{"id":"services"}},[_c('what-wedo')],1),_c('web-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }